module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-compact-up-35c2528d.svg";